'use strict';

angular.module('amexReconciliationApp')
    .component('notifications', {
        templateUrl: 'scripts/views/components/notifications.html',
        controller: function (NotificationsRepository, $uibModal) {
            var self = this;
            self.notifications = [];
            self.broadcastNotifications = [];
            self.systemBroadCastNotifications = [];
            self.totalNotifications = [];
            self.isOpen = false;
            self.loading = false;
            self.totalNotificationsCount = 0;
            self.onNotificationClick = false;
            self.$onInit = function () {
                    self.getAllNotifications();
            };

            self.onClick = function () {
                self.openNotificationsModal();
            };

            self.getAllNotifications = function () {
                self.totalNotifications = [];
                self.totalNotificationsCount = 0;
                NotificationsRepository.notifications = [];

                self.getNotifications();
            };

            self.getNotifications = function () {
                NotificationsRepository.getNotifications().then(function (notifications) {
                    self.totalNotifications = self.totalNotifications.concat(notifications);
                    self.totalNotificationsCount += notifications.length;
                    self.getNotificationsBroadcast();
                },function (error) {
                    self.getNotificationsBroadcast();
                });
            };

            self.getNotificationsBroadcast = function () {
                NotificationsRepository.getNotificationsBroadcast().then(function (notifications) {
                    self.totalNotifications = self.totalNotifications.concat(notifications);
                    self.totalNotificationsCount += notifications.length;
                    self.getNotificationsSystemBroadcast();
                },function (error) {
                    self.getNotificationsSystemBroadcast();
                });
            };

            self.getNotificationsSystemBroadcast = function() {
                NotificationsRepository.getNotificationsSystemBroadcast().then(function (notifications) {
                    self.totalNotifications = self.totalNotifications.concat(notifications);
                    NotificationsRepository.notifications = self.totalNotifications;
                    self.totalNotificationsCount += notifications.length;
                    if (self.totalNotificationsCount > 0 && !NotificationsRepository.notificationsShown ) {
                        self.openNotificationsModal();
                    }
                    NotificationsRepository.notificationsShown = true;
                },function (error) {
                    NotificationsRepository.notifications = self.totalNotifications;
                    if (self.totalNotificationsCount > 0 && !NotificationsRepository.notificationsShown ) {
                        self.openNotificationsModal();
                    }
                    NotificationsRepository.notificationsShown = true;
                });
            };

            self.openNotificationsModal = function () {
                $uibModal.open({
                    template: '<notifications-modal current-page="notifications" close-modal-callback="$close()"></notifications-modal>',
                    size: 'md'
                });
            };
        }
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/notifications.js
// module id = 461
// module chunks = 0